import React, { useEffect, useState } from "react";
import { timezones } from "../config";
import DataOverview from "../components/data/DataOverview";
import Loader from "../components/layouts/Loader";
import { useLocation, useMatch, useParams } from "react-router-dom";

const tableName = "users";
const editPathName = "/settings/users/:id";
const tableColumns = [
  {
    displayName: "First Name",
    dataField: "firstName",
    sort: true,
  },
  {
    displayName: "Last Name",
    dataField: "lastName",
    sort: true,
  },
  {
    displayName: "Email",
    dataField: "email",
    sort: true,
  },
  {
    displayName: "Tools",
    dataField: "tools",
    sort: false,
  },
];
const fieldData = [
  {
    displayName: "User Info",
    fieldName: "titleUsersName",
    fieldType: "title",
    colSize: 1,
  },
  {
    displayName: "First Name",
    fieldName: "firstName",
    fieldType: "text",
    colSize: 3,
    required: true,
  },
  {
    displayName: "Last Name",
    fieldName: "lastName",
    fieldType: "text",
    colSize: 3,
    required: true,
  },
  {
    displayName: "Phone",
    fieldName: "cellPhone",
    fieldType: "phone",
    colSize: 3,
  },
  {
    displayName: "Email",
    fieldName: "email",
    fieldType: "email",
    colSize: 1,
  },
];
const fieldDataDefault = {};

const Users = () => {
  const { id } = useParams();
  let { organizationId } = useParams();
  const { pathname } = useLocation();
  const match = useMatch(editPathName);
  const [loading, setLoading] = useState(true);
  let parentRoute = pathname;

  useEffect(() => {
    setLoading(false);
  }, []);

  if (match) {
    parentRoute = match.pattern.path.replace("/:id", "");
    parentRoute = parentRoute.replace("/:organizationId", "/" + organizationId);
  }
  if (loading) return <Loader />;

  return (
    <DataOverview
      id={id ?? ""}
      organizationId={organizationId ?? ""}
      tableName={tableName}
      pageMode={id ? "edit" : "list"}
      route={pathname}
      parentRoute={parentRoute}
      pageTitle={'Users'}
      listTitle={'Users'}
      listSubTitle={''}
      addTitle={'Add User'}
      addSubTitle={''}
      editTitle={'Edit User'}
      editSubTitle={''}
      tableColumns={tableColumns}
      fieldData={fieldData}
      fieldDataDefault={fieldDataDefault}
    />
  );
};
export default Users;
